import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button, Label, Card, CardBody, UncontrolledTooltip } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Form, Field, FormGroup } from '@availity/form';
import { SelectField } from '@availity/select';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import PractitionerComponent from './Prac-Info-Component';
import ProgressBar from '../../Common/components/ProgressBar';
import qualitystore from '../stores/QualityStore';

@observer
export default class PractionerLocation extends Component {
  constructor(props) {
    super(props);
    if (qualitystore.getPageStatus('#practitionerlocation') !== 'stepwizard-step active') {
      qualitystore.setPageStatus('#practitionerlocation', 'active');
    }
  }

  setPractitionerFirst = event => {
    const { value } = event.target;
    qualitystore.updatePractFirst(value);
  }

  setPractitionerLast = event => {
    const { value } = event.target;
    qualitystore.updatePractLast(value);
  }

  setPractitionerNPI = event => {
    const { value } = event.target;
    qualitystore.updatePractNPI(value);
  }

  addNewPractitioner = () => {
    qualitystore.addPractitioner();
  }

  handleRemovePractitioner = index => {
    qualitystore.removePractitioner(index);
  }

  setLocationName = event => {
    const { value } = event.target;
    qualitystore.updateLocationName(value);
  }

  setLocationStreetSuite = event => {
    const { value } = event.target;
    qualitystore.updateLocationStreetSuite(value);
  }

  locationRegEx = () => {
    if (qualitystore.validateStreetSuite()) {
      return `[~]`;
    }
    return `^[\-0-9a-zA-Z@!&\'\"+=*<># (),.]+$`
  }

  setLocationCity = event => {
    const { value } = event.target;
    qualitystore.updateLocationCity(value);
  }

  locationCityRegEx = () => {
    if (qualitystore.validateCity()) {
      return `[~]`;
    }
    return `^[a-zA-Z][a-zA-Z .,\'()]+$`;
  }

  setLocationState = value => {
    qualitystore.updateLocationState(value);
  }

  setLocationZip = event => {
    const { value } = event.target;
    qualitystore.updateLocationZip(value);
  }

  setLocationContactFirst = event => {
    const { value } = event.target;
    qualitystore.updateLocationContactFirst(value);
  }

  setLocationContactLast = event => {
    const { value } = event.target;
    qualitystore.updateLocationContactLast(value);
  }

  checkPractitionerList = () => {
    const { practitionerList } = qualitystore;
    return practitionerList.every((pract) => {
      return (pract.practFirst !== '' && pract.practLast !== '');
    });
  }

  setLocationContactPhone = event => {
    const { value } = event.target;
    qualitystore.updateLocationContactPhone(value);
  }

  submit = () => {
    const { history } = this.props;
    history.push('/incidentdetails');
  }

  render() {
    const { practitioner, location, states, practitionerList, enableReinitializePracLocation } = qualitystore;

    const initialValuesA = {
      practFirst: practitioner.practFirst,
      practLast: practitioner.practLast,
      practNPI: practitioner.pracNPI,
      locationName: location.name,
      location_streetSuite: location.streetSuite,
      location_city: location.city,
      location_state: location.state,
      location_zip: location.zip,
      location_contactFirst: location.contactFirst,
      location_contactLast: location.contactLast,
      location_contactPhoneExt: location.contactPhoneExt
    }

    const initialValuesB = {};

    const pracLocationShape = {
      practFirst: yup
        .string()
        .matches(/^[A-Za-z]+[ ',.A-Za-z\-]*[ A-Za-z]$/, 'Provider 1 First Name should start and end with a letter.')
        .isRequired((practitioner.practLast !== ''), 'Please enter Provider 1 First Name'),
      practLast: yup
        .string()
        .matches(/^[A-Za-z]+[ ',.A-Za-z\-]*[ A-Za-z]$/, 'Provider 1 Last Name should start and end with a letter.')
        .isRequired((practitioner.practFirst !== ''), 'Please enter Provider 1 Last Name'),
      practNPI: yup.string()
        .matches(/^\d+$/, 'NPI should be exactly 10 Numeric characters only'),
      locationName: yup.string()
        .matches(/^[\d '.A-Za-z\-]+$/, 'No specials characters allowed!')
        .required('Location Name is required!'),
      location_streetSuite: yup.string()
        .matches(this.locationRegEx(), 'Invalid address')
        .required('Street Address/Suite Number is required!'),
      location_city: yup.string()
        .matches(/^[A-Za-z][ '(),.A-Za-z]+$/, 'Invalid City Name')
        .required('City is required!'),
      location_state: yup.string().required('State is required!'),
      location_zip: yup.string()
        .min(5, 'Zip Code must contain 5 digits!')
        .matches(/^\d+$/, 'Zip code must be in numeric!')
        .required('Zip Code is required!'),
      location_contactFirst: yup.string()
        .matches(/^[A-Za-z]+[ ',.A-Za-z\-]*[ A-Za-z]$/, 'Contact First Name should start and end with a letter.')
        .required('Contact First Name is required!'),
      location_contactLast: yup.string()
        .matches(/^[A-Za-z]+[ ',.A-Za-z\-]*[ A-Za-z]$/, 'Contact Last Name should start and end with a letter.')
        .required('Contact Last Name is required!'),
      location_contactPhoneExt: yup.string()
        .min(10, 'Phone number must be at least 10 digits')
        .matches(/^\d{10}(-\d{1,10})?$/, 'Phone Number/Extension is incorrect or incomplete, please enter correct Phone Number/Extension and please include "-"(hyphen) for Extension')
        .required('Phone Number is required!')
    }

    const pracComponentShape = {};

    for (const [index, pract] of practitionerList.entries()) {
      initialValuesB[`practitioner_first_${index}`] = pract.practFirst;
      initialValuesB[`practitioner_last_${index}`] = pract.practLast;
      initialValuesB[`practitionerNPI_${index}`] = pract.pracNPI;

      pracComponentShape[`practitioner_first_${index}`] = yup
        .string()
        .matches(/^[A-Za-z]+[ ',.A-Za-z\-]*[ A-Za-z]$/, `Provider ${index + 2} First Name should start and end with a letter.`);
        // .isRequired((pract.practLast !== ''), `Please enter Provider ${index + 2} First Name`);
      pracComponentShape[`practitioner_last_${index}`] = yup
        .string()
        .matches(/^[A-Za-z]+[ ',.A-Za-z\-]*[ A-Za-z]$/, `Provider ${index + 2} Last Name should start and end with a letter.`);
        // .isRequired((pract.practFirst !== ''), `Please enter Provider ${index + 2} Last Name`);
      pracComponentShape[`practitionerNPI_${index}`] = yup
        .string()
        .matches(/^\d+$/, 'NPI should be exactly 10 Numeric characters only');
    }

    const initialValuesList = { ...initialValuesA, ...initialValuesB };

    const pracValidationShape = { ...pracLocationShape, ...pracComponentShape };

    return (
      <Card>
        <CardBody className="p-40">
          <ProgressBar />
          <NavLink exact to="/memberinfo" className={'btn btn-link backBtn'}>
            <i className="icon icon-angle-left" />
            Back
          </NavLink>
          <div className="border-form">
            <Form
              onSubmit={this.submit}
              initialValues={initialValuesList}
              validationSchema={yup.object().shape(pracValidationShape)}
            >
              <h2 className="primarycardTitle">
                <b>Provider & Location</b>
              </h2>
              <div className="titleSpacer" />
              <p>{`Asterisks (*) mark required fields`}</p>
              <div className='spacer' />
              <h4><b>Provider Information</b></h4>
              <p>Please provide details on the practitioner(s) involved in the incident. Leave blank if not applicable.</p>
              <Row>
                <Col xs="10" sm="11" md="11">
                  <h5>
                    Provider 1
                  </h5>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="6" md="6">
                  <FormGroup for="practFirst">
                    <Label for="practFirst">
                      First Name
                    </Label>
                    <Field
                      type="text"
                      id="practFirst"
                      name="practFirst"
                      value={practitioner.practFirst}
                      onChange={this.setPractitionerFirst}
                      maxLength={50}
                    />
                  </FormGroup>
                </Col>
                <Col xs="12" sm="6" md="6">
                  <FormGroup for="practLast">
                    <Label for="practLast">
                      Last Name
                    </Label>
                    <Field
                      type="text"
                      id="practLast"
                      name="practLast"
                      value={practitioner.practLast}
                      onChange={this.setPractitionerLast}
                      maxLength={50}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="6" md="6">
                  <FormGroup for="practNPI">
                    <Label for="practNPI">
                      NPI
                    </Label>
                    <Field
                      type="text"
                      id="practNPI"
                      name="practNPI"
                      value={practitioner.pracNPI}
                      onChange={this.setPractitionerNPI}
                      maxLength={10}
                    />
                  </FormGroup>
                </Col>
              </Row>
              {practitionerList.map((pract, i) => (
                <div key={i}>
                  <hr />
                  <PractitionerComponent
                    index={i}
                    handleRemovePractitioner={this.handleRemovePractitioner}
                    firstName={pract.practFirst}
                    lastName={pract.practLast}
                    npi={pract.pracNPI}
                  />
                </div>
              ))}
              {practitionerList.length < 3 ?
                <>
                  <p><b>If more than one provider involved: </b></p>
                  <Button className="btn btn-default btn-file" onClick={this.addNewPractitioner}>
                    <i className="icon icon-plus-circle" />
                    Add another provider
                  </Button>
                </>
                :
                null
              }

              <hr className="spacer-both" />

              <h4><b>Location Information</b></h4>
              <p>Please provide details about the location where the incident took place.</p>
              <Row>
                <Col sm="12" md="12">
                  <FormGroup for="locationName">
                    <Label for="locationName">
                      Location Name*
                    </Label>
                    <Field
                      type="text"
                      id="locationName"
                      name="locationName"
                      value={location.name}
                      onChange={this.setLocationName}
                      maxLength={100}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm="12" md="12">
                  <FormGroup for="location_streetSuite">
                    <Label for="location_streetSuite">
                      Street Address/Suite Number*
                    </Label>
                    <Field
                      type="text"
                      id="location_streetSuite"
                      name="location_streetSuite"
                      value={location.streetSuite}
                      onChange={this.setLocationStreetSuite}
                      maxLength={100}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="7" md="7">
                  <FormGroup for="location_city">
                    <Label for="location_city">
                      City*
                    </Label>
                    <Field
                      type="text"
                      id="location_city"
                      name="location_city"
                      value={location.city}
                      onChange={this.setLocationCity}
                      maxLength={50}
                    />
                  </FormGroup>
                </Col>
                <Col xs="12" sm="2" md="2">
                  <FormGroup for="location_state">
                    <Label for="location_state">
                      State*
                    </Label>
                    <SelectField
                      name="location_state"
                      value={location.state}
                      onChange={this.setLocationState}
                      placeholder="Select"
                      options={states.map(state => (
                        {
                          value: state.abbreviation, label: state.name
                        }
                      ))}
                    />
                  </FormGroup>
                </Col>
                <Col xs="12" sm="3" md="3">
                  <FormGroup for="location_zip">
                    <Label for="location_zip">
                      Zip*
                    </Label>
                    <Field
                      type="text"
                      id="location_zip"
                      name="location_zip"
                      placeholder="12345"
                      value={location.zip}
                      onChange={this.setLocationZip}
                      maxLength={5}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="6" md="6">
                  <FormGroup for="location_contactFirst">
                    <Label for="location_contactFirst">
                      Contact First Name*
                    </Label>
                    <Field
                      type="text"
                      id="location_contactFirst"
                      name="location_contactFirst"
                      value={location.contactFirst}
                      onChange={this.setLocationContactFirst}
                      maxLength={50}
                    />
                  </FormGroup>
                </Col>
                <Col xs="12" sm="6" md="6">
                  <FormGroup for="location_contactLast">
                    <Label for="location_contactLast">
                      Contact Last Name*
                    </Label>
                    <Field
                      type="text"
                      id="location_contactLast"
                      name="location_contactLast"
                      value={location.contactLast}
                      onChange={this.setLocationContactLast}
                      maxLength={50}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="6" md="6">
                  <FormGroup for="location_contactPhoneExt">
                    <Label id="locationContactPhoneLabel" for="location_contactPhoneExt">
                      {'Contact Phone-Ext*'}
                      <span id="locationContactPhone-help" className="inline-help" />
                    </Label>
                    <UncontrolledTooltip target="locationContactPhoneLabel" placement="right"
                      innerClassName="text-left">
                      {`Phone Number & Extension format: 0123456789-0123456789; must include "-"(hyphen) for Extension`}
                    </UncontrolledTooltip>
                    <Field
                      type="text"
                      id="location_contactPhoneExt"
                      name="location_contactPhoneExt"
                      value={location.contactPhoneExt}
                      placeholder='0123456789-0123456789'
                      onChange={this.setLocationContactPhone}
                      maxLength={21}
                    />
                  </FormGroup>
                </Col>
              </Row>


              <Button type="submit" color={"primary"} className={'btn btn-primary nextBtn'}>
                Next
              </Button>
            </Form>
          </div>
        </CardBody>
      </Card>
    );
  }
}

PractionerLocation.propTypes = {
  history: PropTypes.object
};